//vista del ticket publico. se usa para que el expositor pueda agregarlo a su lista de contactos
//tambien tiene la funcion para que cada usuario pueda cargar su informacion adicional manualmente

import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { QrCode2Outlined, EventOutlined, AttachMoneyOutlined, Add, InfoOutlined } from '@mui/icons-material';
/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import withAuthenticationRequired from "../../../../components/ProtectedRoutes/withAuthenticationRequired";
import useTicketPublic from './useTicketPublic';
import { config } from '../../../../services/config';
import { api } from '../../../../services/api';
import { Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import Loading from '../../../../components/Loading';
import InfoAdicionalForm from "../../../../components/InfoAdicionalForm"
import NotDesign from '../../../../assets/design-not-available.png';
import ImagenSegura from '../../../../components/ImagenSegura';
import SorteoLanding from './SorteoLanding';
const apiOrigin = config.URL_API;

// eventos que usan la landing especial de sorteo (sin login, solo el formulario).
// hardcodeado por ahora; si se necesita para mas eventos, agregar el id aca.
const EVENTOS_SORTEO = [395, 530, 534, 535];

const TicketPublicView = () => {
  const { codigo } = useParams();
  const history = useHistory();
  const { ticketData, setTicketData, loading, setLoading, error, refetch } = useTicketPublic();
  const [agregando, setAgregando] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  /*   console.log('useParams id (codigo):', codigo);
    console.log(' ticketData:', ticketData); */

  const [showInfoForm, setShowInfoForm] = useState(false);
  const [informacionAdicional, setInformacionAdicional] = useState(null);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [puedeCargarInfo, setPuedeCargarInfo] = useState(false);
  const [yaCargoInfo, setYaCargoInfo] = useState(false);

  const getTicketCodigo = () => {
    if (ticketData?.codigo) {
      // como el codigo viene en una url, sacamos el codigo solo
      const partes = ticketData.codigo.split('/');
      return partes[partes.length - 1];
    }
    return codigo;
  };

  const fetchInformacionAdicional = async () => {
    const ticketCodigo = getTicketCodigo();

    if (!ticketCodigo) {
      /* console.log('No hay código del ticket disponible'); */
      return;
    }

    setLoadingInfo(true);
    try {
      const response = await api.tickets.getInformacionAdicional(ticketCodigo);

      if (response.status === 'success') {

        setInformacionAdicional(response.data);

        // solo se puede cargar (una vez) si hay preguntas y todavia no se cargo nada.
        // una vez cargada, queda bloqueada para siempre, ni el que la cargo la vuelve a ver.
        const puedeCargar = response.data.preguntas?.length > 0 && !response.data.ya_cargado;

        setPuedeCargarInfo(puedeCargar);
        setYaCargoInfo(!!response.data.ya_cargado);

      } else {
        /* console.log('Error en respuesta:', response.message); */
        setPuedeCargarInfo(false);
      }
    } catch (error) {
      console.error('Error al cargar información adicional:', error);
    } finally {
      setLoadingInfo(false);
    }
  };

  useEffect(() => {
    if (ticketData && !loading) {
      fetchInformacionAdicional();
    }
  }, [ticketData, loading]);

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast({ ...toast, open: false });
  };
  const handleAddAsistente = async () => {
    if (!ticketData || agregando) return;

    setAgregando(true);

    try {
      const response = await api.expositores.createAsistente(ticketData.evento.id, {
        idticket: ticketData.id
      });

      if (response.status === 'success') {
        setToast({
          open: true,
          message: 'Asistente agregado exitosamente a tu lista',
          severity: 'success'
        });

        refetch();
      } else {
        throw new Error(response.message || 'Error al agregar asistente');
      }
    } catch (error) {
      setToast({
        open: true,
        message: error.message || 'Error al agregar asistente',
        severity: 'error'
      });
    } finally {
      setAgregando(false);
    }
  };

  const getStatusColor = (estado) => {
    const colors = {
      'VALIDO': '#4CAF50',
      'USADO': '#FF9800',
    };
    return colors[estado] || '#757575';
  };

  const getStatusLabel = (estado) => {
    const labels = {
      'VALIDO': '✅ Válido',
      'USADO': '🎫 Usado',
    };
    return labels[estado] || estado;
  };

  const handleInfoSuccess = () => {
    setToast({
      open: true,
      message: 'Información guardada exitosamente',
      severity: 'success'
    });

    setYaCargoInfo(true);
    fetchInformacionAdicional();
  };

  if (loading || (ticketData && loadingInfo)) {
    return (
      <div style={{
        backgroundColor: "#F9FAFB",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #5656FF',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#6B7280', fontFamily: 'Bricolage Grotesque' }}>
            {loading ? 'Cargando información del ticket...' : 'Cargando información adicional...'}
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
        <div style={{
          backgroundColor: "white",
          padding: "40px",
          margin: "30px",
          borderRadius: "10px",
          border: "1px solid #e4e4e7",
          textAlign: "center"
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
          <h2 style={{ color: '#f44336', marginBottom: '16px', fontFamily: 'Bricolage Grotesque' }}>
            Error al cargar ticket
          </h2>
          <p style={{ color: '#6B7280', marginBottom: '24px', fontFamily: 'Bricolage Grotesque' }}>
            {error}
          </p>
          <button
            onClick={refetch}
            style={{
              backgroundColor: '#5656FF',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Bricolage Grotesque',
              marginRight: '12px'
            }}
          >
            Reintentar
          </button>
          <button
            onClick={() => history.push('/')}
            style={{
              backgroundColor: 'transparent',
              color: '#5656FF',
              border: '2px solid #5656FF',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Bricolage Grotesque'
            }}
          >
            Ir al inicio
          </button>
        </div>
      </div>
    );
  }

  // no ticket
  if (!ticketData) {
    return (
      <div style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
        <div style={{
          backgroundColor: "white",
          padding: "40px",
          margin: "30px",
          borderRadius: "10px",
          border: "1px solid #e4e4e7",
          textAlign: "center"
        }}>
          <p style={{ color: '#6B7280', fontFamily: 'Bricolage Grotesque' }}>
            No se encontró información del ticket
          </p>
        </div>
      </div>
    );
  }

  const routeImage = `${apiOrigin}/eventos/tickets/${ticketData.id}/img`;
  const imageStyle = {
    width: window.innerWidth > 880 ? "400px" : "100%",
    maxWidth: "100%",
    height: "auto"
  };

  return (
    <div style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>

      <div className="d-flex flex-row justify-content-between align-items-center"
        style={{
          backgroundColor: "white",
          borderTop: "1px solid #E4E4E7",
          borderBottom: "1px solid #E4E4E7",
          padding: "15px 20px"
        }}>
        <div className='d-flex flex-row align-items-center gap-3'>
          <QrCode2Outlined style={{ color: "#5656FF", fontSize: "28px" }} />
          <div>
            <p className='mb-0' style={{ fontWeight: "600", fontSize: "16px", color: "#111827" }}>
              {ticketData.evento.nombre}
            </p>
            <p className='mb-0' style={{ fontSize: "14px", color: "#6B7280" }}>
              Información del ticket
            </p>
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <p className='mb-0' style={{ fontSize: "14px", color: "#6B7280" }}>
            Ticket ID: <span style={{ fontWeight: "600", color: "#111827" }}>{ticketData.id}</span>
          </p>
          <div style={{ marginTop: "4px" }}>
            <span style={{
              backgroundColor: getStatusColor(ticketData.estado),
              color: 'white',
              padding: '4px 8px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {getStatusLabel(ticketData.estado)}
            </span>
          </div>
        </div>
      </div>

      {ticketData.puede_agregar && !ticketData.ya_agregado && (
        <div style={{
          backgroundColor: "white",
          padding: "15px 20px",
          margin: "20px 30px 0",
          borderRadius: "10px",
          border: "1px solid #e4e4e7",
          textAlign: "center"
        }}>
          <Button
            onClick={handleAddAsistente}
            disabled={agregando}
            startIcon={agregando ? <CircularProgress size={20} /> : <Add />}
            sx={{
              backgroundColor: '#5656ff',
              color: 'white',
              fontFamily: 'Bricolage Grotesque',
              fontWeight: '600',
              padding: '12px 24px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '16px',
              '&:hover': {
                backgroundColor: '#0b0062'
              },
              '&:disabled': {
                backgroundColor: '#cccccc'
              }
            }}
          >
            {agregando ? 'Agregando...' : 'Agregar a mi lista de visitantes'}
          </Button>
          <p style={{
            fontSize: '14px',
            color: '#6B7280',
            marginTop: '8px',
            marginBottom: '0',
            fontFamily: 'Bricolage Grotesque'
          }}>
            Este asistente será agregado a tu base de datos personal
          </p>
        </div>
      )}

      {/* Si ya fue agregado, mostrar cartel */}
      {ticketData.puede_agregar && ticketData.ya_agregado && (
        <div style={{
          backgroundColor: "#E6E6FF",
          padding: "15px 20px",
          margin: "20px 30px 0",
          borderRadius: "10px",
          border: "1px solid #8E8EFF",
          textAlign: "center"
        }}>
          <p style={{
            fontSize: '16px',
            color: '#0b0062',
            marginBottom: '4px',
            fontFamily: 'Bricolage Grotesque',
            fontWeight: '600'
          }}>
            Ya agregaste este asistente
          </p>
          <p style={{
            fontSize: '14px',
            color: '#0b0062',
            marginBottom: '0',
            fontFamily: 'Bricolage Grotesque'
          }}>
            Este asistente ya está en tu lista personal
          </p>
        </div>
      )}

      {(puedeCargarInfo || yaCargoInfo) && (
        <div style={{
          backgroundColor: "white",
          padding: "15px 20px",
          margin: "20px 30px 0",
          borderRadius: "10px",
          border: "1px solid #e4e4e7",
          textAlign: "center"
        }}>
          {yaCargoInfo ? (
            // si ya hay info cargada, queda bloqueada para siempre (ni el que la cargo
            // la puede volver a ver ni modificar)
            <div>
              <div className="d-flex justify-content-center align-items-center mb-2">
                <InfoOutlined sx={{ color: '#10B981', fontSize: '24px', mr: 1 }} />
                <p style={{
                  fontSize: '16px',
                  color: '#10B981',
                  marginBottom: '0',
                  fontFamily: 'Bricolage Grotesque',
                  fontWeight: '600'
                }}>
                  Información completada
                </p>
              </div>
              <p style={{
                fontSize: '14px',
                color: '#6B7280',
                marginBottom: '0',
                fontFamily: 'Bricolage Grotesque'
              }}>
                Ya has completado la información adicional para este ticket
              </p>
            </div>
          ) : (
            // si no ha cargado, mostrar la opcion de completar
            <div>
              <Button
                onClick={() => setShowInfoForm(true)}
                disabled={loadingInfo}
                startIcon={loadingInfo ? <CircularProgress size={20} /> : <Add />}
                sx={{
                  backgroundColor: '#F59E0B',
                  color: 'white',
                  fontFamily: 'Bricolage Grotesque',
                  fontWeight: '600',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: '#D97706'
                  },
                  '&:disabled': {
                    backgroundColor: '#cccccc'
                  }
                }}
              >
                {loadingInfo ? 'Cargando...' : 'Completar Información Adicional'}
              </Button>
              <p style={{
                fontSize: '14px',
                color: '#6B7280',
                marginTop: '8px',
                marginBottom: '0',
                fontFamily: 'Bricolage Grotesque'
              }}>
                Completa tu información personal para este ticket
              </p>
            </div>
          )}
        </div>
      )}

      <div style={{ backgroundColor: "white", padding: "20px 40px", margin: "30px", borderRadius: "10px", border: "1px solid #e4e4e7" }}>
        <div className='d-flex flex-row justify-content-between align-items-center my-3'>
          <p className='mb-0' style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600" }}>
            Vista previa del ticket
          </p>
        </div>

        <div style={{ borderRadius: "10px", border: "1px solid #e4e4e7", marginBottom: "40px" }}>
          <div className='d-flex justify-content-center'>
            <ImagenSegura
              src={routeImage}
              alt='Imagen del ticket'
              style={imageStyle}
              onError={(e) => {
                e.target.src = NotDesign;
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div style={{
              display: 'none',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              width: '100%'
            }}>
              <div style={{ textAlign: 'center', color: '#6B7280' }}>
                <QrCode2Outlined style={{ fontSize: '48px', marginBottom: '8px' }} />
                <p>Imagen del ticket no disponible</p>
              </div>
            </div>
          </div>
        </div>

        <div style={{}}>
          {/* INFO EVENTO */}
          <div style={{ marginTop: "10px" }}>
            <div className="d-flex flex-row gap-2" style={{ padding: "10px 0 10px", borderBottom: "1px solid #e4e4e7" }}>
              <EventOutlined style={{ color: "#5656FF" }} />
              <p style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600", marginBottom: "0" }}>
                Información del Evento
              </p>
            </div>

            <div style={{ marginTop: "20px" }} className='row'>
              <div className='col-md-6'>
                <div className='d-flex flex-column mb-3'>
                  <p className='mb-1' style={{ fontWeight: "400", color: "#6B7280", lineHeight: "14px", fontSize: "14px" }}>
                    Evento
                  </p>
                  <p className='mb-0' style={{ fontWeight: "500", fontSize: "16px", color: "#111827" }}>
                    {ticketData.evento.nombre}
                  </p>
                </div>
              </div>

              {ticketData.evento.lugar && (
                <div className='col-md-6'>
                  <div className='d-flex flex-column mb-3'>
                    <p className='mb-1' style={{ fontWeight: "400", color: "#6B7280", lineHeight: "14px", fontSize: "14px" }}>
                      Ubicación del evento
                    </p>
                    <p className='mb-0' style={{ fontWeight: "500", fontSize: "16px", color: "#111827" }}>
                      {ticketData.evento.lugar}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* INFO TARIFA*/}
          <div style={{ marginTop: "30px" }}>
            <div className="d-flex flex-row gap-2" style={{ padding: "15px 0 15px", borderBottom: "1px solid #e4e4e7" }}>
              <AttachMoneyOutlined style={{ color: "#5656FF" }} />
              <p style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600", marginBottom: "0" }}>
                Información de la Tarifa
              </p>
            </div>

            <div style={{ marginTop: "20px" }} className='row'>
              <div className='col-md-6'>
                <div className='d-flex flex-column mb-3'>
                  <p className='mb-1' style={{ fontWeight: "400", color: "#6B7280", lineHeight: "14px", fontSize: "14px" }}>
                    Tarifa
                  </p>
                  <p className='mb-0' style={{ fontWeight: "500", fontSize: "16px", color: "#111827" }}>
                    {ticketData.tarifa.concepto}
                  </p>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='d-flex flex-column mb-3'>
                  <p className='mb-1' style={{ fontWeight: "400", color: "#6B7280", lineHeight: "14px", fontSize: "14px" }}>
                    Precio
                  </p>
                  <p className='mb-0' style={{ fontWeight: "600", fontSize: "18px", }}>
                    ${ticketData.tarifa.precio?.toLocaleString('es-AR')}
                  </p>
                </div>
              </div>

              {ticketData.ubicacion && (
                <div className='col-md-6'>
                  <div className='d-flex flex-column mb-3'>
                    <p className='mb-1' style={{ fontWeight: "400", color: "#6B7280", lineHeight: "14px", fontSize: "14px" }}>
                      Ubicación
                    </p>
                    <p className='mb-0' style={{ fontWeight: "500", fontSize: "16px", color: "#111827" }}>
                      {ticketData.ubicacion.nombre}
                    </p>
                  </div>
                </div>
              )}

            </div>
          </div>

        </div>
      </div>

      <InfoAdicionalForm
        open={showInfoForm}
        onClose={() => setShowInfoForm(false)}
        ticketCodigo={getTicketCodigo()}
        onSuccess={handleInfoSuccess}
      />

      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
          sx={{
            width: '100%',
            fontFamily: 'Bricolage Grotesque'
          }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

const ProtectedTicketPublicView = withAuthenticationRequired(TicketPublicView, {
  onRedirecting: () => <Loading />,
  returnTo: window.location.pathname
});

// gate publico (sin login): para eventos de sorteo, si ademas la tarifa tiene
// informacion adicional (rellenada o por rellenar), se muestra la landing directo;
// si no tiene informacion adicional configurada, se mantiene la vista original
// (con su login de siempre), igual que para el resto de los eventos.
const TicketPublic = () => {
  const { codigo } = useParams();
  const [checking, setChecking] = useState(true);
  const [esSorteo, setEsSorteo] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!codigo) {
        setChecking(false);
        return;
      }
      try {
        const response = await api.tickets.getInformacionAdicional(codigo);
        if (response.status === 'success') {
          const esEventoSorteo = EVENTOS_SORTEO.includes(response.data.ticket?.idevento);
          const tieneInfoAdicional = (response.data.preguntas?.length > 0) || !!response.data.ya_cargado;
          setEsSorteo(esEventoSorteo && tieneInfoAdicional);
        } else {
          setNotFound(true);
        }
      } catch (e) {
        setNotFound(true);
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [codigo]);

  if (checking) return <Loading />;

  if (notFound) {
    return (
      <div style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
        <div style={{
          backgroundColor: "white",
          padding: "40px",
          margin: "30px",
          borderRadius: "10px",
          border: "1px solid #e4e4e7",
          textAlign: "center"
        }}>
          <p style={{ color: '#6B7280', fontFamily: 'Bricolage Grotesque' }}>
            No se encontró información del ticket
          </p>
        </div>
      </div>
    );
  }

  if (esSorteo) {
    // misma url de siempre (/tickets/:codigo); el navbar se oculta por CSS
    // via la clase "sorteo-body" que setea SorteoLanding (ver index.css)
    return <SorteoLanding codigo={codigo} />;
  }

  return <ProtectedTicketPublicView />;
};

export default TicketPublic;